import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import MichassIndexActualites from './MichassIndexActualites';
import MichassIndexSlider from './MichassIndexSlider';
import axios from 'axios';

function IndexImage() {
	const [getData, setGetdata] = useState('ok');

	useEffect(() => {

	}, []);


	return (
		<div className="grid grid-cols-1 lg:grid-cols-4 gap-2">
			<div className="flex col-span-3 bg-orange-300 border">
				<img className="w-full" src="img/slider.jpg" alt="image michass" />
			</div>
			<div className="flex bg-gray-100 justify-center">
				<div className="flex flex-col">
					<img src="img/01-01-2024-30.jpg" alt="pasteur" />
				</div>
			</div>
		</div>
	);
}

function IndexAccroche() {
	return (
		<div className="bg-red-500 flex items-center justify-center py-12">
			<div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
				<div className="bg-white flex items-center justify-center rounded-md h-40 w-40 p-2 shadow-md">
			 		<p className="uppercase text-purple-600 text-center">
						Mt 28:19-20<br/>
						allez faites de toutes les nations des disciples ...
					</p>
				</div>
				<div className="bg-white flex items-center justify-center rounded-md h-40 w-40 p-2 shadow-md">
					<p className="uppercase text-purple-600 text-center">
						Année de triomphe en Jésus-Christ
					</p>
				</div>
				<div className="bg-white flex items-center justify-center rounded-md h-40 w-40 p-2 shadow-md">
					<p className="uppercase text-purple-600 text-center">
						Excellente et glorieuse sémaine
					</p>
				</div>
				<div className="bg-white flex items-center justify-center rounded-md h-40 w-40 p-2 shadow-md">
					<p className="uppercase text-purple-600 text-center">
						Temple FAVEUR sis à Yopougon Maroc
					</p>
				</div>
			</div>			
		</div>
	);
}

function IndexEnseignements() {
	return (
		<div className="flex flex-col py-6 px-2" id="michass-index-enseignements">
			<div className="m-2 flex flex-wrap items-center justify-between mb-6">
				<div className="flex flex-wrap items-center text-gray-600"> 
					<svg class="w-[28px] h-[28px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.03v13m0-13c-2.819-.831-4.715-1.076-8.029-1.023A.99.99 0 0 0 3 6v11c0 .563.466 1.014 1.03 1.007 3.122-.043 5.018.212 7.97 1.023m0-13c2.819-.831 4.715-1.076 8.029-1.023A.99.99 0 0 1 21 6v11c0 .563-.466 1.014-1.03 1.007-3.122-.043-5.018.212-7.97 1.023"/>
					</svg>
					<span className="text-3xl">Les enseignements</span> 
				</div>
				<Link to="/enseignements" className="text-purple-600 hover:text-gray-500 flex flex-wrap bg-white px-2 py-1 rounded-sm shadow-sm">
					<span>Voir plus</span>
					<svg class="w-[26px] h-[26px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M19 12H5m14 0-4 4m4-4-4-4"/>
					</svg>
				</Link>
			</div>
			<div className="p-3">
				<div className="flex flex-col gap-4">
					<div className="placeholder-wrapper">
						<div className="placeholder1 loading"></div>
						<div className="placeholder2 loading"></div>
						<div className="placeholder3 loading"></div>
					</div>
					<div className="placeholder-wrapper">
						<div className="placeholder1 loading"></div>
						<div className="placeholder2 loading"></div>
						<div className="placeholder3 loading"></div>
					</div>
					<div className="placeholder-wrapper">
						<div className="placeholder1 loading"></div>
						<div className="placeholder2 loading"></div>
						<div className="placeholder3 loading"></div>
					</div>
					<div className="placeholder-wrapper">
						<div className="placeholder1 loading"></div>
						<div className="placeholder2 loading"></div>
						<div className="placeholder3 loading"></div>
					</div>
					<div className="placeholder-wrapper">
						<div className="placeholder1 loading"></div>
						<div className="placeholder2 loading"></div>
						<div className="placeholder3 loading"></div>
					</div>
				</div>
			</div>
		</div>
	);
}

function IndexCultes() {
	return (
		<div className="flex flex-col py-6" id="michass-index-enseignements">
			<div className="m-2 flex flex-wrap items-center justify-between mb-4">
				<div className="flex flex-wrap items-center text-gray-600"> 
					<svg class="w-[28px] h-[28px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
						<path fill-rule="evenodd" d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z" clip-rule="evenodd"/>
					</svg>
					<span className="text-2xl">Cultes d'adoration et d'action de grâce</span> 
				</div>
				<Link to="/cultes" className="text-purple-600 hover:text-gray-500 flex flex-wrap bg-white px-2 py-1 rounded-sm shadow-sm">
					<span>Voir plus</span>
					<svg class="w-[26px] h-[26px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M19 12H5m14 0-4 4m4-4-4-4"/>
					</svg>
				</Link>
			</div>
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
				<div className="bg-white">
					<img className="border mb-2" src="img/construction.jpg" alt="construction" />
					<div className="flex flex-wrap justify-between items-center">
						<div className="placeholder-wrapper w-9/12">
							<div className="placeholder1 loading"></div>
						</div>
						<Link to="/cultes" className="text-white flex flex-wrap px-2 py-1 bg-purple-500 w-2/12">
							<span>Lire</span>
							<svg class="w-[26px] h-[26px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M19 12H5m14 0-4 4m4-4-4-4"/>
							</svg>
						</Link>
					</div>
				</div>
				<div className="bg-white px-3">
					<div className="flex flex-col">
						<div className="flex mb-3">
							<div className="bg-white flex flex-wrap">
								<img className="border mb-2 w-1/2" src="img/construction.jpg" alt="construction" />
								<div className="flex flex-wrap justify-between items-center w-1/2 pl-2">
									<div className="placeholder-wrapper w-full">
										<div className="placeholder1 loading"></div>
										<div className="placeholder2 loading"></div>
										<div className="placeholder3 loading"></div>
									</div>
								</div>
							</div>
						</div>
						<div className="flex">
							<div className="bg-white flex flex-wrap">
								<img className="border mb-2 w-1/2" src="img/construction.jpg" alt="construction" />
								<div className="flex flex-wrap justify-between items-center w-1/2 pl-2">
									<div className="placeholder-wrapper w-full">
										<div className="placeholder1 loading"></div>
										<div className="placeholder2 loading"></div>
										<div className="placeholder3 loading"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function IndexGalerie() {
	return (
		<div className="flex flex-col py-6 mt-12" id="michass-index-galerie">
			<div className="m-2 flex flex-wrap items-center justify-between mb-4">
				<div className="flex flex-wrap items-center text-gray-600"> 
					<svg class="w-[28px] h-[28px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
						<path fill-rule="evenodd" d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z" clip-rule="evenodd"/>
					</svg>
					<span className="text-2xl">Photos & Vidéos</span> 
				</div>
				<Link to="/galerie" className="text-purple-600 hover:text-gray-500 flex flex-wrap bg-white px-2 py-1 rounded-sm shadow-sm">
					<span>Voir plus</span>
					<svg class="w-[26px] h-[26px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M19 12H5m14 0-4 4m4-4-4-4"/>
					</svg>
				</Link>
			</div>
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
				<div className="bg-white">
					<img className="border mb-2" src="img/construction.jpg" alt="construction" />
				</div>
				<div className="bg-white px-3">
					<div className="flex flex-col">
						<div className="flex items-center justify-center bg-red-100 py-28">
							<svg class="w-[48px] h-[48px] text-red-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
								<path fill-rule="evenodd" d="M21.7 8.037a4.26 4.26 0 0 0-.789-1.964 2.84 2.84 0 0 0-1.984-.839c-2.767-.2-6.926-.2-6.926-.2s-4.157 0-6.928.2a2.836 2.836 0 0 0-1.983.839 4.225 4.225 0 0 0-.79 1.965 30.146 30.146 0 0 0-.2 3.206v1.5a30.12 30.12 0 0 0 .2 3.206c.094.712.364 1.39.784 1.972.604.536 1.38.837 2.187.848 1.583.151 6.731.2 6.731.2s4.161 0 6.928-.2a2.844 2.844 0 0 0 1.985-.84 4.27 4.27 0 0 0 .787-1.965 30.12 30.12 0 0 0 .2-3.206v-1.516a30.672 30.672 0 0 0-.202-3.206Zm-11.692 6.554v-5.62l5.4 2.819-5.4 2.801Z" clip-rule="evenodd"/>
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function IndexContact() {
	return (
		<div className="flex bg-black mt-8 text-white py-16 text-2xl font-bold hover:bg-red-700 transition-all duration-500">
			<Link to="/contact" className="text-xl m-auto">
				Vous avez bien choisi de nous visiter. <br/>Merci de nous faire parvenir vos impressions et appréciations pour une meilleure communication.<br/>
				<svg class="w-[32px] h-[32px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
					<path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="m3.5 5.5 7.893 6.036a1 1 0 0 0 1.214 0L20.5 5.5M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"/>
				</svg>
			</Link>
		</div>
	);
}

function IndexCommentaires() {
	return (
		<div className="flex flex-col mt-12 p-4" id="michass-index-enseignements">
			<p className="uppercase text-2xl mb-4">quelques témoignages</p>
			<div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
				<div className="bg-gray-50 shadow-md p-2">
					<span className="italic text-red-600 border-1 border-b border-green-500 pb-1">Pypo Kouakou</span>
					<p className="my-2">Ammmmmmmmmmmmennnnnnnn hoooôo au Nom de Notre Sauveur et Seigneur JÉSUS CHRIST, Demeure Richement Béni Homme de DIEU 🙏🙏</p>
					<span className="float-right text-gray-400 text-sm">Jeud 10 Oct 2024 - 05:59</span>
				</div>
				<div className="bg-gray-50 shadow-md p-2">
					<span className="italic text-red-600 border-1 border-b border-green-500 pb-1">Gouênestepou Yoroba</span>
					<p className="my-2">Un thème révélateur !</p>
					<span className="float-right text-gray-400 text-sm">Jeud 10 Oct 2024 - 00:49</span>
				</div>
				<div className="bg-gray-50 shadow-md p-2">
					<span className="italic text-red-600 border-1 border-b border-green-500 pb-1">Max Fallo Gnaba</span>
					<p className="my-2">Que le seigneur te remplisse abondamment</p>
					<span className="float-right text-gray-400 text-sm">Merc 9 Oct 2024 - 20:13</span>
				</div>
			</div>
		</div>
	);
}

function MichassIndex() {
	return (
		<div>
			<IndexImage />
			<IndexAccroche />
			<IndexEnseignements />
			<IndexCultes />
			<IndexGalerie />
			<IndexContact />
			<br/><br/><br/>
			<IndexCommentaires />
			<br/><br/><br/>
		</div>
	);
}

export default MichassIndex;